/* Not exported with the library. You'll want something similar to this for uniquely identifying external hosts in your App */
const ODR = Symbol("ODR");
const IDADMIN = Symbol("IDADMIN");

export const apiHosts = {
  ODR,
  IDADMIN,
};
